import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.function.name";
import _toConsumableArray from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectServe from "@/components/SelectServe.vue";
import TreeSelect from "@/components/TreeSelect.vue";
import chargePerson from "@/components/management/reportManage/chargePerson.vue";
import { hallSaveOrUpdate } from "@/api/managementCenter/serveManage";
import { getRoleList, getDeptTree, getUserPageTwo } from "@/api/managementCenter/otherApi";
import { serveFileUpload, serveFileDelete } from "@/api/managementCenter/otherApi";
import cropperImg from "@/components/common/cropperImg.vue";
import quillEditorCom from "@/components/common/quillEditor.vue";
import request from "@/util/http";
export default {
  name: "ServeDialog",
  components: {
    SelectServe: SelectServe,
    chargePerson: chargePerson,
    TreeSelect: TreeSelect,
    cropperImg: cropperImg,
    quillEditorCom: quillEditorCom
  },
  props: [],
  data: function data() {
    return {
      problemList: [],
      userList: [],
      serveParamSearch: {
        current: 1,
        size: 10
      },
      serveTotal: 0,
      type: "",
      plateData: [{
        value: "1",
        name: "PC平台"
      }, {
        value: "2",
        name: "移动平台"
      }],
      serveTypeList: [{
        name: "请选择",
        value: ""
      }, {
        name: "查询类",
        value: "0"
      }, {
        name: "审批类",
        value: "1"
      }],
      applyTypeList: [{
        name: "请选择",
        value: ""
      }, {
        name: "线上",
        value: "1"
      }, {
        name: "线下",
        value: "2"
      }, {
        name: "线上和线下",
        value: "3"
      }],
      feeWayList: [{
        name: "请选择",
        value: ""
      }, {
        name: "免费",
        value: "免费"
      }, {
        name: "收费",
        value: "收费"
      }],
      onlineTime: [{
        name: "请选择",
        value: ""
      }, {
        name: "半天",
        value: "半天"
      }, {
        name: "全天",
        value: "全天"
      }],
      policyType: [{
        name: "请选择",
        value: ""
      }, {
        name: "国家法规",
        value: "1"
      }, {
        name: "地方法规",
        value: "2"
      }, {
        name: "行政法规",
        value: "3"
      }, {
        name: "学校政策",
        value: "4"
      }, {
        name: "部门规章",
        value: "5"
      }, {
        name: "其他",
        value: "6"
      }],
      roleSelect: [],
      roleList: [],
      departmentData: [],
      mapKey: {
        id: "id",
        // ID
        label: "name",
        // 显示名称
        children: "children" //子级字段名

      },
      imgSrc: "",
      fileList: [],
      serveList: [],
      show: false,
      loading: false,
      title: "",
      serveImgList: [],
      processImgList: [],
      onlineDescImgList: [],
      offlineDescImgList: [],
      startRuleList: [{
        value: "0",
        label: "只允许发起一次"
      }, {
        value: "1",
        label: "仅能存在一条运行实例"
      }, {
        value: "2",
        label: "不限制"
      }],
      form: {
        recommend: 0,
        applyCondition: "",
        applyType: "",
        attention: "",
        plateform: [],
        belongDeptId: "",
        serveCover: "",
        checkPersons: "",
        contact: "",
        startRule: "",
        contactMobile: "",
        fileList: [{
          fileId: "",
          fileType: ""
        }],
        id: "",
        intro: "",
        offlineDesc: {
          handleTime: "",
          handleDesc: "",
          place: "",
          feeWay: "",
          handleDegist: ""
        },
        onlineDesc: {
          handleTime: "",
          handleDesc: "",
          feeWay: ""
        },
        offlineDescImg: "",
        onlineDescImg: "",
        processDefId: "",
        processImg: "",
        processVersionId: "",
        qaList: [],
        roleList: [],
        policy: [],
        serveName: "",
        periordValidateHours: "",
        serveType: 0,
        watchDeptId: "",
        queryType: "",
        hostFlag: "0"
      },
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: null,
        type: "radio"
      },
      userText: "",
      userId: [],
      rules: {
        serveName: [{
          required: true,
          message: "请输入服务名称",
          trigger: "blur"
        }],
        serveType: [{
          required: true,
          message: "请选择服务类型",
          trigger: "change"
        }],
        queryType: [{
          required: true,
          message: "请选择查询类型",
          trigger: "change"
        }],
        startRule: [{
          required: true,
          message: "请选择启动规则",
          trigger: "change"
        }],
        serveCover: [{
          required: true,
          message: "请上传服务图片",
          trigger: "blur"
        }],
        processDefId: [{
          required: true,
          message: "请输入流程ID",
          trigger: "blur"
        }],
        processVersionId: [{
          required: true,
          message: "请输入流程版本",
          trigger: "blur"
        }],
        plateform: [{
          type: "array",
          required: true,
          message: "请选择可用平台",
          trigger: "change"
        }],
        processImg: [{
          required: true,
          message: "请上传流程图片",
          trigger: "blur"
        }],
        roleList: [{
          required: true,
          message: "请选择服务角色对象",
          trigger: "change"
        }],
        contactMobile: [{
          required: true,
          message: "请输入联系方式",
          trigger: "blur"
        }],
        contact: [{
          required: true,
          message: "请输入联系人",
          trigger: "blur"
        }],
        checkPersons: [{
          required: true,
          message: "请选择负责人",
          trigger: "blur"
        }],
        belongDeptId: [{
          required: true,
          message: "请选择归属部门",
          trigger: "change"
        }],
        watchDeptId: [{
          required: true,
          message: "请选择监管部门",
          trigger: "change"
        }],
        applyType: [{
          required: true,
          message: "请选择申请方式",
          trigger: "change"
        }],
        applyCondition: [{
          required: true,
          message: "请输入申请条件",
          trigger: "blur"
        }],
        queryPcUrl: [{
          required: false,
          message: "请输入pc端链接地址",
          trigger: "blur"
        }],
        queryMobileUrl: [{
          required: false,
          message: "请输入移动端链接地址",
          trigger: "blur"
        }]
      }
    };
  },
  computed: {},
  mounted: function mounted() {},
  methods: {
    handleCurrentChange: function handleCurrentChange(value) {
      this.serveParamSearch.current = value;
      this.getUserPage();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.serveParamSearch.size = value;
      this.serveParamSearch.current = 1;
      this.getUserPage();
    },
    // setValue(data) {
    //     this.form.checkPersons=data
    //
    // },
    onRemoveImg: function onRemoveImg(file, key) {
      var _this = this;

      if (!file.id) {
        return;
      }

      this.deleteFile(file.id, function () {
        _this[key] = [];
      });
    },
    beforeRemoveOn: function beforeRemoveOn(file) {
      var _this2 = this;

      if (!file.id) {
        return;
      }

      this.deleteFile(file.id, function () {
        _this2.onlineDescImgList = _this2.onlineDescImgList.filter(function (i) {
          return file.id != i.id;
        });
      });
    },
    beforeRemoveOff: function beforeRemoveOff(file) {
      var _this3 = this;

      if (!file.id) {
        return;
      }

      this.deleteFile(file.id, function () {
        _this3.offlineDescImgList = _this3.offlineDescImgList.filter(function (i) {
          return file.id != i.id;
        });
      });
    },
    onPreviewFn: function onPreviewFn(file) {
      window.open(file.fileUrl);
    },
    deleteFile: function deleteFile(id, callBack) {
      var _this4 = this;

      serveFileDelete(id).then(function (_ref) {
        var data = _ref.data;

        if (data.code == 0) {
          callBack && callBack();

          _this4.$message.success("删除成功!");
        } else {
          _this4.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this4.$message.error("删除异常!");
      });
    },
    serveImgBeforeUpload: function serveImgBeforeUpload(file) {
      this.handleBeforeUpload(file, "0", "serveImgList");
    },
    processImgBeforeUpload: function processImgBeforeUpload(file) {
      this.handleBeforeUpload(file, "1", "processImgList");
    },
    onlineDescImgBeforeUpload: function onlineDescImgBeforeUpload(file) {
      this.handleBeforeUpload(file, "3", "onlineDescImgList");
    },
    offlineDescImgBeforeUpload: function offlineDescImgBeforeUpload(file) {
      this.handleBeforeUpload(file, "4", "offlineDescImgList");
    },
    setDeptSingleMenu: function setDeptSingleMenu(key, data) {
      //获取子组件值
      this.form.belongDeptId = data.id;
    },
    setDeptSingleMenuTwo: function setDeptSingleMenuTwo(key, data) {
      //获取子组件值
      this.form.watchDeptId = data.id;
    },
    getUserPage: function getUserPage() {
      var _this5 = this;

      getUserPageTwo(this.serveParamSearch).then(function (_ref2) {
        var data = _ref2.data;

        if (data.code == 0) {
          _this5.userList = (data.data.records || []).map(function (i) {
            return {
              name: i.username,
              value: i.userId + ""
            };
          });
          _this5.serveTotal = data.data.total;
        }
      });
    },
    getDeptTreeData: function getDeptTreeData() {
      var _this6 = this;

      getDeptTree().then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          if (data.data && data.data.length > 0) {
            if (data.data[0].id == 1) {
              _this6.departmentData = data.data[0].children;
            } else {
              _this6.departmentData = data.data;
            }
          }

          if (_this6.type == "edit") {
            _this6.$nextTick(function () {
              // 编辑时部门回显
              _this6.$refs.deptSingle.setKey(_this6.form.belongDeptId);

              if (_this6.form.serveType == "1") {
                _this6.$refs.deptSingleTwo.setKey(_this6.form.watchDeptId);
              }
            });
          }
        }
      }).catch(function (err) {});
    },
    getRoleListData: function getRoleListData() {
      var _this7 = this;

      getRoleList().then(function (_ref4) {
        var data = _ref4.data;

        if (data.code == 0) {
          _this7.roleList = data.data.map(function (i) {
            return _objectSpread(_objectSpread({}, i), {}, {
              roleId: i.roleId + ""
            });
          });
        }
      }).catch(function (err) {});
    },
    addPolicyFn: function addPolicyFn() {
      this.form.policy.push({
        name: "",
        type: "",
        rules: "",
        content: ""
      });
    },
    delPolicy: function delPolicy(index) {
      this.form.policy.splice(index, 1);
    },
    addProblemFn: function addProblemFn() {
      this.form.qaList.push({
        question: "",
        answer: ""
      });
    },
    delAsk: function delAsk(index) {
      this.form.qaList.splice(index, 1);
    },
    uploadHttp: function uploadHttp(file) {
      var _this8 = this;

      var type = "0";
      var key = "serveImgList";
      var fd = new FormData();
      fd.append("file", file); //上传到后台

      this.loading = true;
      serveFileUpload(fd).then(function (_ref5) {
        var data = _ref5.data;
        _this8.loading = false;

        if (data.code == 0) {
          _this8.$refs.cropperImg.closeDialog();

          _this8.$message.success("上传文件成功!");

          _this8[key].push(_objectSpread(_objectSpread({}, data.data), {}, {
            fileType: type,
            fileId: data.data.id,
            fileUrl: data.data.url,
            name: data.data.relatedFileName
          }));
        } else {
          _this8.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this8.loading = false;

        _this8.$message.error("上传文件异常!");
      });
    },
    // 上传文件之前的方法
    handleBeforeUpload: function handleBeforeUpload(file, type, key) {
      var _this9 = this;

      if (type != 0) {
        var isLt4M = file.size / 1024 / 1024 < 4;

        if (!isLt4M) {
          this.$message.error("上传文件大小不能超过 4MB!");
          return isLt4M;
        }
      } else {
        this.$refs.cropperImg.uploadImg(file);
        return;
      }

      var fd = new FormData();
      fd.append("file", file); //上传到后台

      this.loading = true;
      serveFileUpload(fd).then(function (_ref6) {
        var data = _ref6.data;
        _this9.loading = false;

        if (data.code == 0) {
          _this9.$message.success("上传文件成功!");

          _this9[key].push(_objectSpread(_objectSpread({}, data.data), {}, {
            fileType: type,
            fileId: data.data.id,
            fileUrl: data.data.url,
            name: data.data.relatedFileName
          }));
        } else {
          _this9.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this9.loading = false;

        _this9.$message.error("上传文件异常!");
      });
    },
    handlePreview: function handlePreview() {
      window.location.href = this.fileList[0].url;
    },
    sureSelect: function sureSelect(data) {
      this.serveList = data;
    },
    serveSelect: function serveSelect() {
      this.$refs.selectServeRef.openDialog(this.serveList);
    },
    handleClose: function handleClose(tag) {
      this.serveList = this.serveList.filter(function (item) {
        return item.serve_id != tag.serve_id;
      });
    },
    // 显示弹框
    dialogShow: function dialogShow(type, data) {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.serveImgList = [];
        this.processImgList = [];
        this.offlineDescImgList = [];
        this.onlineDescImgList = [];
        this.roleSelect = [];
        this.userText = "";
        this.type = type;

        switch (type) {
          case "add":
            this.fileList = [];
            this.title = "新增服务";
            this.form = {
              recommend: 0,
              applyCondition: "",
              applyType: "",
              attention: "",
              plateform: [],
              belongDeptId: "",
              checkPersons: "",
              serveCover: "",
              contact: "",
              contactMobile: "",
              startRule: "",
              fileList: [],
              id: "",
              intro: "",
              offlineDesc: {
                handleTime: "",
                handleDesc: "",
                feeWay: "",
                place: "",
                handleDegist: ""
              },
              onlineDesc: {
                handleTime: "",
                handleDesc: "",
                feeWay: ""
              },
              offlineDescImg: "",
              onlineDescImg: "",
              processDefId: "",
              processImg: "",
              processVersionId: "",
              policy: [],
              qaList: [{
                answer: "",
                id: "",
                question: ""
              }],
              roleList: [{
                roleId: ""
              }],
              serveName: "",
              periordValidateHours: "",
              serveType: 0,
              watchDeptId: "",
              queryPcUrl: "",
              queryMobileUrl: "",
              queryType: "",
              hostFlag: 0
            };
            break;

          case "edit":
            this.title = "编辑服务";
            var offlineDesc = {
              handleTime: "",
              handleDesc: "",
              feeWay: "",
              place: "",
              handleDegist: ""
            };
            var onlineDesc = {
              handleTime: "",
              handleDesc: "",
              feeWay: ""
            };

            if (data.offlineDesc) {
              var offlineDescParse = JSON.parse(data.offlineDesc);

              if (!offlineDescParse.hasOwnProperty("place")) {
                offlineDescParse.place = "";
              }

              offlineDesc = offlineDescParse;
            }

            if (data.onlineDesc) {
              onlineDesc = JSON.parse(data.onlineDesc);
            }

            var policy;

            if (data.policy) {
              try {
                policy = JSON.parse(data.policy);
              } catch (e) {
                policy = [];
              }
            } else {
              policy = [];
            }

            this.form = {
              recommend: data.recommend ? Number(data.recommend) : 0,
              applyCondition: data.applyCondition,
              applyType: data.applyType,
              attention: data.attention,
              belongDeptId: (data.belongDept || {}).id || "",
              checkPersons: (data.checkUser || {}).userId || "",
              contact: data.contact,
              startRule: data.startRule,
              contactMobile: data.contactMobile,
              serveCover: "",
              fileList: [],
              id: data.id,
              intro: data.intro,
              offlineDesc: offlineDesc,
              onlineDesc: onlineDesc,
              offlineDescImg: "",
              onlineDescImg: "",
              plateform: data.plateform.split(","),
              queryPcUrl: data.queryPcUrl,
              queryMobileUrl: data.queryMobileUrl,
              policy: policy,
              processDefId: data.processDefId,
              processImg: "",
              processVersionId: data.processVersionId,
              qaList: data.qaList,
              roleList: data.roleList,
              serveName: data.serveName,
              periordValidateHours: data.periordValidateHours,
              serveType: Number(data.serveType),
              queryType: Number(data.queryType),
              watchDeptId: (data.watchDept || {}).id || "",
              hostFlag: data.hostFlag ? Number(data.hostFlag) : 0
            };
            this.userText = (data.checkUser || {}).userName || "";
            this.roleSelect = (data.roleList || []).map(function (i) {
              return i.id + "";
            });
            var fileList = data.fileList;
            this.serveImgList = this.byFileTypeGetList(fileList, "0");
            this.processImgList = this.byFileTypeGetList(fileList, "1");
            this.onlineDescImgList = this.byFileTypeGetList(fileList, "3");
            this.offlineDescImgList = this.byFileTypeGetList(fileList, "4");
            break;
        }
      });
    },
    saveOrUpdate: function saveOrUpdate() {
      var _this10 = this;

      this.loading = true;
      var params = JSON.parse(JSON.stringify(this.form));
      params = _objectSpread(_objectSpread({}, params), {}, {
        fileList: [].concat(_toConsumableArray(this.serveImgList), _toConsumableArray(this.processImgList), _toConsumableArray(this.onlineDescImgList), _toConsumableArray(this.offlineDescImgList)),
        offlineDesc: JSON.stringify(params.offlineDesc),
        onlineDesc: JSON.stringify(params.onlineDesc),
        policy: JSON.stringify(params.policy),
        plateform: params.plateform.join(",")
      });
      delete params.serveCover;
      delete params.processImg;
      delete params.onlineDescImg;
      delete params.offlineDescImg;

      if (params.qaList && params.qaList.length == 1 && !params.qaList[0].answer && !params.qaList[0].question) {
        params.qaList = [];
      }

      hallSaveOrUpdate(params).then(function (_ref7) {
        var data = _ref7.data;
        _this10.loading = false;

        if (data.code == 0) {
          _this10.$message.success("保存成功!"); // this.show=false


          _this10.close();

          _this10.$emit("saveSuccess");
        } else {
          _this10.$message.warning(data.msg || "保存失败!");
        }
      }).catch(function (err) {
        _this10.loading = false; // this.$message.error(  "服务器异常!" );
      });
    },
    //显示人员选择
    addUser: function addUser() {
      var _this11 = this;

      this.personData.state = true;
      this.$nextTick(function () {
        if (_this11.form.checkPersons) {
          _this11.personData.userData = [_this11.form.checkPersons];
          _this11.personData.data = [{
            userId: _this11.form.checkPersons,
            name: _this11.userText
          }];
        } else {
          _this11.personData.userData = [];
          _this11.personData.data = [];
        }

        _this11.$refs.personModal.loadData();
      });
    },
    //选择人员
    closePerson: function closePerson(value) {
      if (!value.mans) {
        this.personData.state = false;
        return;
      }

      var mans = value.mans || [];
      this.userText = mans[0].name;
      this.form.checkPersons = mans[0].userId;
      this.personData.state = false;
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this12 = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this12.saveOrUpdate();
        } else {
          return false;
        }
      });
    },
    close: function close() {
      this.show = false;
      this.fileList = [];
      this.form = {
        recommend: 0,
        applyCondition: "",
        applyType: "",
        attention: "",
        plateform: [],
        belongDeptId: "",
        checkPersons: "",
        serveCover: "",
        contact: "",
        contactMobile: "",
        startRule: "",
        fileList: [],
        id: "",
        intro: "",
        offlineDesc: {
          handleTime: "",
          handleDesc: "",
          feeWay: "",
          place: "",
          handleDegist: ""
        },
        onlineDesc: {
          handleTime: "",
          handleDesc: "",
          feeWay: ""
        },
        offlineDescImg: "",
        onlineDescImg: "",
        processDefId: "",
        processImg: "",
        processVersionId: "",
        policy: [],
        qaList: [{
          answer: "",
          id: "",
          question: ""
        }],
        roleList: [{
          roleId: ""
        }],
        serveName: "",
        periordValidateHours: "",
        serveType: 0,
        watchDeptId: "",
        queryPcUrl: "",
        queryMobileUrl: "",
        queryType: "",
        hostFlag: 0
      };
      this.$refs["ruleForm"].resetFields();
    },
    byFileTypeGetList: function byFileTypeGetList(arr, type) {
      var list = arr.filter(function (i) {
        return i.fileType == type;
      });
      return list.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          url: i.fileUrl,
          id: i.fileId,
          name: i.relatedFileName
        });
      });
    },
    //可用平台chenge事件
    plateChange: function plateChange(arr) {
      if (!arr.includes("2")) {
        this.rules.queryMobileUrl[0].required = false;
      } else {
        this.rules.queryMobileUrl[0].required = true;
      }

      if (!arr.includes("1")) {
        this.rules.queryPcUrl[0].required = false;
      } else {
        this.rules.queryPcUrl[0].required = true;
      }
    }
  },
  watch: {
    roleSelect: function roleSelect(value) {
      this.form.roleList = value.map(function (i) {
        return {
          roleId: i
        };
      });
    },
    serveImgList: function serveImgList(value) {
      this.form.serveCover = value.length ? "true" : "";
    },
    processImgList: function processImgList(value) {
      this.form.processImg = value.length ? "true" : "";
    },
    offlineDescImgList: function offlineDescImgList(value) {
      this.form.offlineDescImg = value.length ? "true" : "";
    },
    onlineDescImgList: function onlineDescImgList(value) {
      this.form.onlineDescImg = value.length ? "true" : "";
    },
    show: function show(value) {
      if (!value) {
        this.serveList = [];
      } else {
        // 打开弹框时，获取岗位和角色数据
        this.getDeptTreeData();
        this.getRoleListData();
        this.getUserPage();
      }
    }
  },
  filters: {}
};